import type { LeadKind } from "@ckgo2/shared/types";
import i18n from "@/i18n";

/**
 * Popisky typu poptávky (`leads.kind`). Sdílená EN mapa pro `LeadKind` neexistuje, takže tu
 * není `enumLabel`, ale lokální `Record` z literálních klíčů `t()` (typovaný `t()` dynamický
 * klíč nepustí). Modulová úroveň je bezpečná: přepnutí jazyka stránku znovu načte.
 */
export const LEAD_KIND_LABEL: Record<LeadKind, string> = {
  inquiry: i18n.t("crm.leads.kinds.inquiry"),
  callback: i18n.t("crm.leads.kinds.callback"),
};

/**
 * Štítek typu poptávky. Jen u žádosti o zavolání: výchozí typ „poptávka“ by byl šum v každém
 * řádku seznamu i v hlavičce detailu, proto pro něj nevrací nic.
 */
export function LeadKindBadge({ kind, className }: { kind: LeadKind; className?: string }) {
  if (kind === "inquiry") return null;
  return (
    <span className={`badge badge-warning${className ? ` ${className}` : ""}`}>
      {LEAD_KIND_LABEL[kind]}
    </span>
  );
}
